import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { AppInjector } from '../../../app-injector';
import store from "../../../store/store.module";

@Pipe({
  name: 'followCurrency',
  pure: false
})
export class FollowCurrencyPipe implements PipeTransform, OnDestroy {
  store;
  unsubscribe;
  selectedCurrency;
  currencies = [];

  constructor() {
    this.setCurrency((store as any).getState());
    let subscribeCurrency = store.subscribe(() => {
      if ((store as any).getState().RootReducer) {
        this.setCurrency((store as any).getState());
        subscribeCurrency();
      }
    });

  }

  ngOnDestroy(): void {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  setCurrency(state) {
    if (state.RootReducer.attributes.currency.fetched) {
      this.currencies = state.RootReducer.attributes.currency.items;
    }
    this.selectedCurrency = state.RootReducer.attributes.currency.selected;
  }

  round(price) {
    return Math.round(price * 100) / 100;
  }

  concatCurrency(symbol, price) {
    return `${symbol} ${price}`;
  }

  transform(price: number | number[], currencyCode?: string) {
    let prices: number[];
    if (!Array.isArray(price)) {
      if (!price) {
        return 0;
      }
      prices = [price];
    } else {
      prices = price as number[];
    }
    if (this.currencies.length === 0) {
      return prices.reduce((acc, cur) => acc + cur, 0);
    }
    if (this.selectedCurrency) {
      if (currencyCode) {
        const prevCurrency = this.currencies.find(s => s.code === currencyCode);
        if (prevCurrency) {
          const totalInPrevCurrency = prices.reduce((acc, cur) => {
            // convert to base first
            const baseCurrencyPrice = cur * (prevCurrency.rate || 1);
            return acc + this.round((baseCurrencyPrice * (this.selectedCurrency.rate || 1)));
          }, 0);
          return this.concatCurrency(prevCurrency.code, this.round(totalInPrevCurrency));
        }
       }
      const total = prices.reduce((acc, cur) => {
        return acc + this.round((cur * (this.selectedCurrency.rate || 1)));
      }, 0);
      return this.concatCurrency(this.selectedCurrency.code, this.round(total));
    }
    return price;
  }
}
